export default "__VITE_ASSET__B0dGx_cW__"